// extracted by mini-css-extract-plugin
export var anchor = "index-module--anchor--nnY9Q";
export var iconWrapper = "index-module--icon-wrapper--qCqVy";
export var iconWrapperX = "index-module--icon-wrapper-x--X9zg5";
export var list = "index-module--list--8rBuC";
export var listItem = "index-module--list-item--YBsi3";